import styled from 'styled-components';
import tw from 'tailwind-styled-components';
import { ReactNode } from 'react';

export const FilterCategoryWrapper = styled.div<{
  children?: ReactNode;
  className?: string;
}>`
  @media screen and (min-width: 768px) {
    display: flex;
    align-items: center;
  }
`;
export const CategoryWrapper = styled.div<{
  children?: ReactNode;
  className?: string;
}>`
  @media screen and (min-width: 768px) {
    width: calc(100% - 310px);
  }
`;
export const FilterWrapper = styled.div`
  @media screen and (min-width: 768px) {
    width: 300px;
  }
`;

export const FileContainer = styled.a<{
  $cursor: boolean;
  children?: ReactNode;
  className?: string;
  href?: string;
  onClick?: (e: MouseEvent) => void;
}>`
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(221, 221, 221, 1);
  border-radius: 10px;
  height: 12rem;
  ${({ $cursor }) => ($cursor ? 'cursor: pointer;' : 'cursor: default;')}

  > img,
  > svg {
    width: 100px;
    min-height: 100px;
    object-fit: contain;
  }
`;

export const IconContainer = styled.a<{
  children?: ReactNode;
  className?: string;
  href?: string;
  onClick?: (e: MouseEvent) => void;
}>`
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(221, 221, 221, 1);
  border-radius: 10px;
  height: 12rem;
  cursor: pointer;
`;

export const ImageContainer = styled.a<{
  $cursor: boolean;
  children?: ReactNode;
  className?: string;
  href?: string;
  onClick?: (e: MouseEvent) => void;
}>`
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  height: 12rem;
  cursor: pointer;
  display: block;
  ${({ $cursor }) => ($cursor ? 'cursor: pointer;' : 'cursor: default;')}

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
`;

export const ModalContainer = styled.div`
  top: 0;
  left: 0;
  position: fixed;
  display: block;
  z-index: 1000;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.75);
`;

export const ModalContent = styled.div`
  width: 100%;
  max-width: 870px;
  max-height: 715px;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  position: absolute;
  background-color: #fdfbf9;
  border-radius: 16px;
  padding: 30px;
  display: flex;
  flex-direction: column;
`;

export const ModalContentVideo = styled.figure`
  video {
    width: 100%;
    height: 100%;
  }
`;

export const ModalContentAudio = styled.figure`
  width: 100%;
  audio {
    width: 100%;
  }
`;

export const ModalContentImage = styled.picture`
  display: flex;
  align-content: stretch;
  align-items: stretch;
  overflow: hidden;
  img {
    object-fit: contain;
  }
`;

export const ModalBottomComp = tw.div`
  mt-4
  flex
  flex-row
  justify-between
  `;

export const Dots = styled.span`
  display: inline-block;
  width: 4px;
  height: 4px;
  background-color: #000;
  border-radius: 4px;
  margin: 3px 5px;
`;

export const MediaLibraryItemWrapper = tw.div`
mb-4
md:pb-8
flex
flex-col
w-full
md:h-full
justify-between
`;

export const MediaLibraryItemButton = styled.div`
  button {
    color: rgba(1, 14, 84, 1);
    border-color: rgba(1, 14, 84, 1);
    > div {
      color: rgba(1, 14, 84, 1);
    }
  }
`;
